import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import './TariffsPeriodSwitch.less';
import PERIODS from '../../../constants/periods';
import {t} from '../../../services/i18nHandler';

const periods = [
  {
    label: PERIODS.ONE_MONTH.LABEL,
    value: PERIODS.ONE_MONTH.VALUE,
  },
  {
    label: PERIODS.THREE_MONTHS.LABEL,
    value: PERIODS.THREE_MONTHS.VALUE,
  },
  {
    label: PERIODS.SIX_MONTHS.LABEL,
    value: PERIODS.SIX_MONTHS.VALUE,
  },
  {
    label: PERIODS.TWELVE_MONTHS.LABEL,
    value: PERIODS.TWELVE_MONTHS.VALUE,
  },
];

function TariffsPeriodSwitch({onClick, activePeriod, hidden}) {
  if (hidden) {
    return null;
  }

  const isActive = useMemo(() => (month) => activePeriod === month, [activePeriod]);

  return (
    <div className="tariffs_period-switch">
      {periods.map((p) => (
        <div
          key={p.value}
          role="button"
          onClick={() => onClick(p.value)}
          className={`tariffs_period-switch_item ${isActive(p.value) ? 'active' : ''}`}
        >
          {t(p.label)}
        </div>
      ))}
    </div>
  );
}

TariffsPeriodSwitch.defaultProps = {
  activePeriod: PERIODS.ONE_MONTH.VALUE,
  onClick: () => {},
  hidden: false,
};

TariffsPeriodSwitch.propTypes = {
  activePeriod: PropTypes.number,
  onClick: PropTypes.func,
  hidden: PropTypes.bool,
};

export default TariffsPeriodSwitch;
